import React from 'react';
import PropTypes from 'prop-types';

import {
  Icon, Badge,
} from '../../ui-kit';
import './styles.scss';

const ButtonsGroup = (props) => (
  <div
    className={`buttons_group__container ${
      props.loading ? 'buttons_group__disabled' : ''
    }`}
  >
    {props.badges.map((item, index) => (
      <>
        <Badge
          onClick={() => {
            props.setActiveTab(index, item.name.toLowerCase());
            if (item.onClick) {
              item.onClick();
            }
          }}
          active={props.activeTabIndex === index}
          value={item.name}
          rightArrow={item.rightArrow}
        />
        {item.separator && (
          <div className="buttons_group_separator" />
        )}
      </>
    ))}
    <button className="buttons_group_refresh" onClick={() => props.refreshAction()}>
      <Icon name="refresh" />
    </button>
  </div>
);

ButtonsGroup.propTypes = {
  loading: PropTypes.bool,
  badges: PropTypes.array,
  activeTabIndex: PropTypes.number,
  refreshAction: PropTypes.func,
  setActiveTab: PropTypes.func,
};
ButtonsGroup.defaultProps = {
  loading: false,
  badges: [],
  setActiveTab: () => {},
  refreshAction: () => {},
  activeTabIndex: null,
};

export default ButtonsGroup;
